var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('paginated-list',{attrs:{"actions":_vm.actions,"columns":_vm.columns,"service":"support-articles","state-key":"supportArticles"}})}
var staticRenderFns = []

export { render, staticRenderFns }